import * as React from 'react'
import { DOM, IOO, pipe } from '@packages/prelude'
import styled from 'styled-components'
import 'bootstrap'
import '../css/main.scss'
import image from '../images/werk85-Logo-banner.png'
import { react } from './commons'

const DemoImage = styled.img.attrs({
  src: `${image as string}`
})`
  width: 100%;
`

const App: React.FC = () => (
  <>
    <DemoImage />
  </>
)

const program = pipe(document, DOM.querySelector('#app'), IOO.map(react.mountTo(() => <App />)))

program()
